import { AnimatedNumber } from '../AnimatedNumber/AnimatedNumber';
import './StatValue.css';

interface StatValueProps {
  value: string | number;
  label: string;
  variant?: 'default' | 'alert' | 'ok';
}

export function StatValue({ value, label, variant = 'default' }: StatValueProps) {
  const variantClass = variant !== 'default' ? `StatValue-value--${variant}` : '';

  return (
    <div className="StatValue">
      <div className={`StatValue-value ${variantClass}`}>
        {typeof value === 'number' ? (
          <AnimatedNumber value={value} decimals={0} />
        ) : (
          value
        )}
      </div>
      <div className="StatValue-label">{label}</div>
    </div>
  );
}
